export default class Combo {
    /**
     * 
     * @param {string} select 
     * @param {boolean} opt.modal
     * @param {number} opt.minimumInputLength
     */
    constructor(select, opt) {
        opt.minimumInputLength = opt.minimumInputLength || 3;
        this.options = {
            minimumInputLength: opt.minimumInputLength
        };
        this.select = select;
        if (opt.modal !== undefined && opt.modal) {
            this.options['dropdownParent'] = $('.modal-content');
        }
    }

    simple() {
        $(this.select).select2(this.options);
    }


    /**
     * 
     * @param {string} opt.placeholder que dirá en el combo de forma visible
     * @param {callback} opt.templateResult como formatear los resultados
     * @param {string} opt.url url
     * @param {callback} opt.data callback para enviar datos
     * @param {callback} opt.processResults callback para procesar resultados
     */
    remote(opt) {
        let myself = this;
        this.options['placeholder'] = opt.placeholder || 'Buscar';
        if (opt.templateResult !== undefined) {
            this.options['templateResult'] = function(state) {
                return opt.templateResult(state);
            }
        }
        this.options['ajax'] = {
            url: opt.url
        };
        if (opt.data !== undefined) {
            this.options.ajax['data'] = function(params) {
                return opt.data(params);
            };
        }
        if (opt.processResults !== undefined) {
            this.options.ajax['processResults'] = function(data) {
                return opt.processResults(data);
            };
        }
        $(this.select).select2(this.options);
    }
}